import queryKeys from '@/util/hooks/queries/queryKeys';
import { useQuery } from '@tanstack/react-query';

import { erpSyncApi } from '../../api/erpSync.api';

export interface UseSupplierUpdateRecordsParams {
  search?: string;
  outstandingSection?: string;
  page?: number;
  pageSize?: number;
}

/**
 * Feature #7210 / S1 + S14 (REQ-036, REQ-081..084): the persistent, server-side searched/filtered/
 * paged supplier-update records list — one row per (client, supplier) pair, including pairs whose
 * work is fully decided ("Completed"), unlike `usePendingApprovalsList` which only shows currently
 * open bundles. `placeholderData` keeps the previous page's rows on screen while a new page/filter
 * is loading, so the table doesn't flash to a skeleton on every keystroke/page change.
 */
export const useSupplierUpdateRecords = (params: UseSupplierUpdateRecordsParams = {}) => {
  const { search, outstandingSection, page = 1, pageSize = 25 } = params;

  return useQuery({
    queryKey: [
      queryKeys.supplierUpdateRecords,
      search,
      outstandingSection,
      page,
      pageSize
    ],
    queryFn: () =>
      erpSyncApi.queries.getSupplierUpdateRecords({
        search,
        outstandingSection,
        page,
        pageSize
      }),
    placeholderData: (previousData) => previousData
  });
};
